import React, { useEffect } from 'react';
import styles from './style.module.css';
import { BackPage, OrderBar } from 'components';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import chevronBlack from 'assets/chevron-right-black.svg';
import * as Types from 'helpers/types';
import { PharmacyDeliveryPageContent } from 'services/content';

const PharmacyDelivery = () => {
  const history = useHistory();
  const pharmaciesInRange = useSelector((state) => state.paymentJourney.pharmaciesInRange);
  const dispatch = useDispatch();
  const startedJourney = useSelector((state) => state.paymentJourney.started);

  useEffect(() => {
    if (!startedJourney) history.push('/pharmacy/dashboard');
  }, [history, startedJourney]);

  const updateAddress = (e, address) => {
    e.stopPropagation();
    dispatch({ type: Types.ODS_SET, payload: address.ods_code });
    history.push('/pharmacy/dashboard/basket');
  };

  return (
    <>
      <OrderBar currentProgress={0} />
      <BackPage onBackClick={() => history.goBack()}>
        <h1 className={styles.header}>{PharmacyDeliveryPageContent.headingText}</h1>
        <ul className={styles.pharmacylistContainer}>
          {pharmaciesInRange.map((pharmacy) => (
            <li key={pharmacy.address.ods_code} className={`${styles.boxContainer} drop-shadow`}>
              <div
                className={styles.boxContainer__grid}
                tabIndex="0"
                onKeyPress={(event) => (event.key === 'Enter' ? updateAddress(event, pharmacy) : null)}
                onClick={(event) => updateAddress(event, pharmacy)}>
                <div>
                  <p className={styles.pharmacySmallText}>{pharmacy.distance_in_miles} miles</p>
                  <h2 className={styles.pharmacyName}>{pharmacy.name}</h2>
                  <p className={styles.pharmacyText}>{pharmacy.address.address_line1}</p>
                  <p className={styles.pharmacyText}>{pharmacy.address.address_line2}</p>
                  <p className={styles.pharmacyText}>
                    {pharmacy.address.address_line4 ? `${pharmacy.address.address_line4}, ` : null}
                    {pharmacy.address.postcode}
                  </p>
                  <p className={styles.pharmacyText}>{pharmacy.phone}</p>
                </div>
                <div className={styles.imgContainer}>
                  <img src={chevronBlack} alt="" />
                </div>
              </div>
            </li>
          ))}
        </ul>
      </BackPage>
    </>
  );
};

export default PharmacyDelivery;
